export { default as PriceAndCalories } from './price-and-calories';
